import dayjs from 'dayjs';
import _ from 'lodash';
import moment from 'moment';
import customParseFormat from 'dayjs/plugin/customParseFormat'

dayjs.extend(customParseFormat)

//TO DO: ADD NEW SHORT DESCRIPTION FOR NEW DEPARTMENTS
export const API = {
  logbooks: {
    path: '/logbooks?populate[id_driver_in_charge][populate][id_users_permissions_user][fields]=name,surname&populate[id_location][marina][$containsi]=&populate[id_yacht][populate][id_attendance][populate][id_provenence_list][populate][provenence]=%2A&populate[id_yacht][populate][id_yacht_members][populate][id_users_permissions_user]=%2A&populate[id_department]=%2A&populate[id_supplier]=%2A&populate[manager][populate][id_users_permissions_user][fields]=name,surname&populate[id_operator][populate][id_users_permissions_user][fields]=name,surname&populate[id_list_items][populate][id_list][populate][id_delivery_note]=%2A&populate[id_delivery_note]=%2A',
    method: 'GET',
    get: null,
    auth: true,
    fallback: null,
    transform: (data) => {
      return {
        meta: data?.meta,
        data: data?.data.map((item) => ({
          id: item?.id,
          attributes: {
            ...item?.attributes,
            collection_delivery_date_id: {
              collection_delivery_date:
                item?.attributes?.collection_delivery_date,
              id: item?.id,
            },
            collection_delivery_time_id: {
              collection_delivery_time:
                item?.attributes?.collection_delivery_time,
              id: item?.id,
            },
            id_driver_in_charge_id: {
              id_driver_in_charge:
                item?.attributes?.id_driver_in_charge?.data?.attributes
                  ?.id_users_permissions_user?.data?.attributes,
              id: item?.attributes?.id_driver_in_charge?.data?.id,
              id_operation: item?.id,
            },
            id_operator_id: {
              id_operator:
                item?.attributes?.id_operator?.data?.attributes
                  ?.id_users_permissions_user?.data?.attributes,
              id: item?.id,
            },
            status_logbook_id: {
              status_logbook: item?.attributes?.status_logbook,
              id: item?.id,
            },
            delivery_notes_id: {
              id: item?.id,
              delivery_notes: item?.attributes?.delivery_notes,
            },
            time_notes_id: {
              id: item?.id,
              time_notes: item?.attributes?.time_notes,
            },
            collection_delivery_notes_id: {
              id: item?.id,
              collection_delivery_notes:
                item?.attributes?.collection_delivery_notes,
            },
            id_delivery_note_id: {
              id_department:
                item?.attributes?.id_department?.data?.attributes
                  ?.short_description,
              delivery_note:
                item?.attributes?.id_delivery_note?.data?.attributes
                  ?.delivery_note_number ||
                item?.attributes?.id_list_items?.data?.[0]?.attributes?.id_list
                  ?.data?.attributes?.id_delivery_note?.data?.attributes
                  ?.delivery_note_number,
            },
            delivery_manager_on_board:
              item?.attributes?.id_yacht?.data?.attributes?.id_yacht_members?.data?.filter(
                (user) =>
                  user?.attributes?.is_delivery_manager_on_board === true
              )?.[0] || null,
          },
        })),
      };
    },
  },
  operation: {
    path: '/logbooks/{{id}}?populate[id_driver_in_charge][populate][id_users_permissions_user][fields]=name,surname&populate[id_location][marina][$containsi]=&populate[id_department]=%2A&populate[id_supplier]=%2A&populate[manager][populate][id_users_permissions_user][fields]=name,surname&populate[id_yacht][populate][id_flag]=%2A&populate[id_yacht][populate][id_attendance][populate][id_agent_NA][populate][id_users_permissions_user][fields][0][1]=name,surname&populate[id_yacht][populate][id_attendance][populate][id_provenence_list][populate][provenence]=%2A&populate[id_list_items][populate][id_list][populate][id_operation_list][populate][id_service]=%2A&populate[id_operator][populate][id_users_permissions_user][fields]=name,surname&populate[id_user_last_updated][populate][id_users_permissions_user]=%2A&populate[id_delivery_note][populate][id_operation_list]=%2A&populate[id_delivery_yacht][populate][id_yacht]=%2A',
    method: 'GET',
    get: null,
    auth: true,
    fallback: null,
    transform: (data) => ({
      ...data,
      data: {
        attributes: {
          ...data?.data?.attributes,
          id_list_items: !_.isEmpty(data?.data?.attributes?.id_list_items?.data)
            ? {
              ...data?.data?.attributes?.id_list_items,
              id_department:
                data?.data?.attributes?.id_department?.data?.attributes
                  ?.short_description,
              id_logbook: data?.data?.id,
              yacht_name:
                data?.data?.attributes?.id_yacht?.data?.attributes
                  ?.yacht_name || null,
              service:
                data?.data?.attributes?.id_list_items?.data[0]?.attributes
                  ?.id_list?.data?.attributes?.id_operation_list?.data
                  ?.attributes?.id_service?.data?.attributes?.service || null,
            }
            : null,
          requested_date: data?.data?.attributes?.requested_date
            ? moment(data?.data?.attributes?.requested_date).format(
              'DD-MM-YYYY'
            )
            : null,
          list_status: !_.isEmpty(data?.data?.attributes?.id_list_items?.data)
            ? {
              list_item_status:
                data?.data?.attributes?.id_list_items?.data[0]?.attributes
                  ?.id_list?.data?.attributes?.list_item_status,
              list_item_status_depot:
                data?.data?.attributes?.id_list_items?.data[0]?.attributes
                  ?.id_list?.data?.attributes?.list_item_status_depot,
              id_department:
                data?.data?.attributes?.id_department?.data?.attributes
                  ?.short_description,
            }
            : null,
          id_list: !_.isEmpty(data?.data?.attributes?.id_list_items?.data)
            ? {
              ...data?.data?.attributes?.id_list_items?.data[0]?.attributes
                ?.id_list,
              check_depot_department: {
                id_department:
                  data?.data?.attributes?.id_department?.data?.attributes
                    ?.short_description,
                check_depot:
                  data?.data?.attributes?.id_list_items?.data[0]?.attributes
                    ?.id_list?.data?.attributes?.check_depot,
              },
            }
            : null,

          id_delivery_note_id: {
            id_department:
              data?.data?.attributes?.id_department?.data?.attributes,
            delivery_note:
              data?.data?.attributes?.id_delivery_note?.data?.attributes
                ?.delivery_note_number,
            id_operation_list:
              data?.data?.attributes?.id_delivery_note?.data?.attributes
                ?.id_operation_list?.data?.id,
          },
        },
      },
    }),
  },
  update: {
    path: '/logbooks/{{id}}?populate[id_driver_in_charge][populate][id_users_permissions_user][fields]=name,surname&populate[id_location][marina][$containsi]=&populate[id_yacht]=%2A&populate[id_department]=%2A&populate[id_supplier]=%2A&populate[manager][populate][id_users_permissions_user][fields]=name,surname&populate[id_list_items][populate][id_list]=%2A&populate[id_delivery_yacht][populate][id_yacht]=%2A',
    method: 'PUT',
    get: null,
    auth: true,
    fallback: null,
    adapter: (body) => ({
      data: {
        ...body,
        id_delivery_yacht:
          body?.operation_type === 'PICKUP SUPPLIER'
            ? body?.id_delivery_yacht?.id || null
            : null,
        id_yacht: body?.id_yacht?.id,
        operation_type: body?.operation_type,
        id_marina: body?.id_marina?.id,
        id_location: body?.id_location?.id,
        id_department: body?.id_department?.id,
        id_supplier: body?.id_supplier?.id,
        id_driver_in_charge: body?.id_driver_in_charge?.id
          ? body?.id_driver_in_charge?.id
          : null,
        priority: body?.priority?.id,
        status_logbook: body?.status_logbook,
        collection_delivery_date: body?.collection_delivery_date
          ? dayjs(body?.collection_delivery_date).format('YYYY-MM-DD')
          : null,
        collection_delivery_time: body?.collection_delivery_time
          ? dayjs(body?.collection_delivery_time).format('HH:mm:ss')
          : null,
        logbook_date: body?.logbook_date
          ? dayjs(body?.logbook_date).format('YYYY-MM-DD')
          : null,
      },
    }),
  },
  delete: {
    path: '/logbooks/{{id}}',
    method: 'DELETE',
    get: null,
    auth: true,
    fallback: null,
  },
  create: {
    path: '/logbooks',
    method: 'POST',
    get: null,
    auth: true,
    fallback: null,
    adapter: (body) => {
      return {
        data: {
          ...body,
          id_delivery_yacht:
            body?.operation_type === 'PICKUP SUPPLIER'
              ? body?.id_delivery_yacht?.id || null
              : null,
          id_yacht: body?.id_yacht?.id,
          operation_type: body?.operation_type,
          manager: body?.manager?.id,
          id_marina: body?.id_marina?.id,
          id_department: body?.id_department?.id,
          id_supplier: body?.id_supplier?.id,
          id_driver_in_charge: body?.id_driver_in_charge?.id,
          priority: body?.priority?.id,
          status_logbook: body?.status_logbook,
          collection_delivery_date: body?.collection_delivery_date
            ? dayjs(body?.collection_delivery_date).format('YYYY-MM-DD')
            : null,
          collection_delivery_time: body?.collection_delivery_time
            ? dayjs(body?.collection_delivery_time).format('HH:mm:ss')
            : null,
          logbook_date: body?.logbook_date
            ? dayjs(body?.logbook_date).format('YYYY-MM-DD')
            : null,
        },
      };
    },
  },
  selectDeliveryYacht: {
    path: '/logbooks?filters[operation_type][$eq]=DELIVERY YACHT&pagination[page]=1&pagination[pageSize]=1000&sort[collection_delivery_date]=asc&sort[collection_delivery_time]=asc&populate[id_yacht]=%2A&populate[id_department]=%2A',
    method: 'GET',
    get: null,
    auth: true,
    fallback: [],
    transform: (data) =>
      data?.data?.map((item) => ({
        name: `#${item?.id} - ${item?.attributes?.id_yacht?.data?.attributes?.yacht_name || 'N/A'} - ${item?.attributes?.id_department?.data?.attributes?.name_department || ''} - ${item?.attributes?.collection_delivery_date ? dayjs(item.attributes.collection_delivery_date).format('DD/MM/YYYY') : ''} - ${item?.attributes?.collection_delivery_time ? dayjs(item.attributes.collection_delivery_time, 'HH:mm:ss').format('HH:mm') : ''} `,
        id: item?.id,
      })),
  },
  createFromList: {
    path: '/logbooks',
    method: 'POST',
    get: null,
    auth: true,
    fallback: null,
    adapter: (body) => {
      return {
        data: {
          ...body,
        },
      };
    },
  },
  updateFromList: {
    path: '/logbooks/{{id}}',
    method: 'PUT',
    get: null,
    auth: true,
    fallback: null,
    adapter: (body) => {
      const collection_delivery_time = body?.collection_delivery_time
        ? {
          collection_delivery_time: body?.collection_delivery_time
            ? dayjs(body?.collection_delivery_time, 'HH:mm:ss').format('HH:mm:ss')
            : null,
        }
        : null;
      const data = {
        ...body,
        ...collection_delivery_time,
      };
      return { data: data };
    },
  },
  updateAllRows: {
    path: '/logbooks/updateMany',
    method: 'PUT',
    get: null,
    auth: true,
    fallback: null,
    adapter: (body) => ({
      data: {
        ...body,
      },
    }),
  },
  createFromItemsList: {
    path: '/logbooks',
    method: 'POST',
    get: null,
    auth: true,
    fallback: null,
    adapter: (body) => {
      return {
        data: {
          ...body,
          collection_delivery_date: dayjs(
            body?.collection_delivery_date
          ).format('YYYY-MM-DD'),
          collection_delivery_time: dayjs(
            body?.collection_delivery_time
          ).format('HH:mm:ss'),
          logbook_date: dayjs().format('YYYY-MM-DD'),
          id_location: body?.id_location?.id,
          id_supplier: body?.id_supplier?.id,
          status_request_logbook: 'OPEN',
          status_logbook: 'NEW REQUEST',
        },
      };
    },
  },
  updateFromItemsList: {
    path: '/logbooks/{{id}}',
    method: 'PUT',
    get: null,
    auth: true,
    fallback: null,
    adapter: (body) => {
      return {
        data: {
          ...body,
        },
      };
    },
  },
};
